import { type FC } from 'react'

import { ErrorPage } from '@/components/pages'

export const NotfoundPage: FC = () => {
  return (
    <div className="flex h-full flex-col justify-center">
      <ErrorPage className="flex-1" code={404} />
    </div>
  )
}
